import { Navigate, useParams } from 'react-router-dom'

/** Legacy `/property/:id` deep links → map centered on the property with modal open. */
export function PropertyProfileRedirect() {
  const { propertyId } = useParams<{ propertyId: string }>()
  if (!propertyId) return <Navigate to="/map" replace />
  return <Navigate to={`/map?property=${encodeURIComponent(propertyId)}`} replace />
}
